"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActivePath = void 0;
function isActivePath(input) {
    if (typeof window === 'undefined')
        return false;
    if (!input)
        return false;
    var currentPath = removeTrailingSlash(window.location.pathname) || '/';
    var inputPath = removeTrailingSlash(input) || '/';
    // home page
    if (['/', '/us', '/cn'].includes(inputPath)) {
        if ((currentPath === '/us' && inputPath === '/cn') ||
            (currentPath === '/cn' && inputPath === '/us')) {
            return false;
        }
        if (['/', '/us', '/cn'].includes(currentPath))
            return true;
        // other pages
    }
    else {
        // Support input path with and without the region
        var currentPathWithoutRegion = removeRegion(currentPath);
        var inputPathWithoutRegion = removeRegion(inputPath);
        if (currentPathWithoutRegion.startsWith(inputPathWithoutRegion)) {
            return true;
        }
    }
    return false;
}
exports.isActivePath = isActivePath;
function removeTrailingSlash(str) {
    return str.replace(/\/+$/, '');
}
function removeRegion(str) {
    // Remove /us or /cn only if followed by a slash or at the end of the string (homepage)
    return str.replace(/^\/(us|cn)(\/|$)/, '/');
}
